import CheckoutError from './CheckoutError.js'

export default class PurchaseCheckoutError extends CheckoutError {}
